<template lang="pug">
v-dialog(v-model="dialog", persistent, max-width="400")
  template(v-slot:activator="{ on }") 
    v-btn(text, v-on="on", color="primary", height="60px", style="font-weight:400") Keluar
      v-icon.mx-1(small) mdi-logout-variant
  v-card
    v-toolbar(flat, justify-end, text-right)
      v-spacer
      v-toolbar-title.title-text.error--text.mr-6 KELUAR SYSTEM
      v-spacer
    v-card-text.text-center.mt-2 
      v-layout
        v-flex(lg3, md3, xs3) 
          v-icon.error--text(large) mdi-logout-variant
        v-flex(lg9, md9, xs9) 
          .text-left.caption {{ message }}
    v-card-actions.justify-center
      v-btn.mb-3(
        color="error",
        width="150px",
        style="font-size: 10px",
        @click="doLogout"
      ) Ya, Keluar
        v-icon(small) mdi-logout-variant
      v-btn.mb-3(
        outlined,
        color="error",
        width="150px",
        style="font-size: 10px",
        @click="closeDialog"
      ) Tidak, Batalkan
</template>
<script>
export default {
  name: "FDialogLogout",
  props: ["username", "value"],
  data() {
    return {
      dialog: false,
      message: "Apakah anda yakin ingin keluar dari system ?",
    };
  },
  watch: {
    value(val) {
      this.dialog = val ? val : false;
    },
  },
  mounted() {
    this.dialog = this.value ? this.value : false;
  },
  methods: {
    doLogout() {
      this.dialog = false;
      this.$progress.show(true);

      this.$http
        .get("/api/sec/logout", { params: { username: this.username } })
        .then(
          (success) => {
            this.$session.clear();
            if (this.$socket.isStarted()) {
              this.$socket.deactivate();
            }

            this.$router.push({ name: "login" }).catch((err) => {});
          },
          (err) => {
            this.$session.clear();
            if (this.$socket.isStarted()) {
              this.$socket.deactivate();
            }

            this.$router.push({ name: "login" }).catch((err) => {});
          }
        )
        .finally(() => this.$progress.show(false), this.closeDialog());
    },
    closeDialog() {
      this.dialog = false;
      this.$emit("dialog", false);
    },
  },
};
</script>